module.exports = __webpack_public_path__ + "media/Video 80.7844c063.mp4";